import authApi from '@/api/login'
import authorityApi from '@/api/authority/authority'
// import { getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { asyncRouterMap } from '@/router/index'
import { Message } from 'element-ui';
const user = {
  namespaced: true,
  state: {
    token: getToken(),
    name: '',
    roleName: '',
    orgGuid: '',
    avatar: '',
    roleGuid: '',
    roles: [],
    perms: [],
    init: false, // 是否完成初始化 // 默认未完成
    RouterList: [] // 动态路由
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLENAME: (state, roleName) => {
      state.roleName = roleName
    },
    SET_ORGGUID: (state, orgGuid) => {
      state.orgGuid = orgGuid
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLEGUID: (state, roleGuid) => {
      state.roleGuid = roleGuid
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    set_router: (state, RouterList) => {
      state.RouterList = RouterList
    },
    set_init: (state, status) => {
      state.init = status
    }
  },

  actions: {
    // 登录
    login({ commit }, userInfo) {
      // console.log(userInfo)
      let _this = this;
      return new Promise((resolve, reject) => {
        authApi.login(userInfo)
          .then(response => {
            // console.log(response)
            if(response.code == 0){
              if(response.orgCheckState == 0){
                Message({message:'错误提示：机构未审核，审核通过后登录。',type: 'error'});
              }else{
                const token = response.token
                // console.log(response)
                setToken(token)
                sessionStorage.setItem("loginName",response.data.loginName);
                sessionStorage.setItem("orgGuid",response.data.orgGuid);
                sessionStorage.setItem("userGuid",response.data.guid);
                sessionStorage.setItem("customerType",response.data.customerType);
                commit('SET_NAME',response.data.loginName)
                commit('SET_ORGGUID', response.data.orgGuid)
                commit('SET_AVATAR', response.data.headImage)
                commit('SET_ROLEGUID', response.data.roleGuid)
                commit('SET_TOKEN', token)
                resolve(response)
              }
              // else{
              //   const token = response.token
              //   setToken(token)
              //   commit('SET_TOKEN', token)
              //   resolve()
              // }
            }else{
              Message({message:'错误提示：'+ response.msg,type: 'error'});
            }

          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        let token = {
          token: state.token
        }
        authorityApi.querySystemPermssionByParentIdNavigation(token)
          .then(response => {
            // console.log(response)
            if(response.code == 0){
              const data = response.data;
              // console.log(data)
              if (data && data.length > 0) {
                // 验证返回的roles是否是一个非空数组
                // console.log(data)
                commit('SET_ROLES',data)
              } else {
                reject('getInfo: roles must be a non-null array !')
              }
              // console.log(data.roleGuid)

              resolve(response)
            }else{
              // console.log(111111)
              reject(response.msg)
              Message({message:'错误提示：'+ response.msg,type: 'error'});
            }

          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 动态设置路由 此为设置设置途径
    setRouterList({ commit }, routerList) {
      commit('set_router', asyncRouterMap.concat(routerList)) // 进行路由拼接并存储
    },
    // 存储颗粒话权限
    setroles({ commit }, roleList) {
      commit('SET_ROLES', roleList)
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        authApi.logout().then(res => {
          // console.log(res)
            if(res.code == 0){
              commit('SET_TOKEN', '')
              commit('SET_ROLES', [])
              commit('set_router', [])
              commit('SET_NAME', '')
              commit('SET_ROLENAME', '')
              commit('SET_AVATAR', '')
              commit('SET_ROLEGUID','')
              removeToken()
              resolve()
            }else{
              Message({message:'错误提示：'+ response.msg,type: 'error'});
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端 登出(测试方法)
    logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('set_router', [])
        commit('SET_NAME', '')
        commit('SET_ROLENAME', '')
        commit('SET_AVATAR', '')
        commit('SET_ROLEGUID','')
        removeToken();
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js